<template>
    <div class="container mt-10" >
            <div class="lg:w-96 w-72">
                <div class="extrabold text-3xl mb-2">{{name}}: {{Time.points}}</div>
                <div :class='"grid  border-gray-500 rounded-lg shadow-2xl h-16 " + Player.color' @click="ClickStarter()">
                    <div class="extrabold text-4xl self-center">
                        <span class="">{{calculateMinutes}}:{{calculateSeconds}}:{{calculateMilliseconds}}</span>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    props: {
        id: String,
        name: String,
        points: Number
    },
    data(){
        return{
            socket: this.$store.state.socket,
            roomId: this.$store.state.roomId,
            host: this.$store.state.host,
            Time: {
                minutes: 0,
                seconds: 0,
                milliseconds: 0,
                sinceStarted: 0,
                running: false,
                destroyed: false,
                points: this.points
            },
            Player: {
                color: "bg-gray-400"
            }
        }
    },
    mounted(){
        window.addEventListener('keydown', event => {
            if(event.keyCode === 32){
                if(this.id === this.socket.id){
                    this.Player.color = "bg-green-500"
                }
            }
        })
        window.addEventListener('keyup', event => {
            if(event.keyCode === 32){
                if(this.id == this.socket.id){
                    this.handler()
                    this.Player.color = "bg-gray-400"
                }
            }
        })
        this.socket.on("started", (id) => {
            if(id === this.id){
                if(!this.Time.running){
                    this.start()
                }
            }
        })
        this.socket.on("stopped", async (payload) => {
            if(payload.id === this.id){
                this.stop()
                await this.Sleep(100)
                this.Time.milliseconds = Math.floor(payload.time % 1000)
                this.Time.seconds = Math.floor((payload.time / 1000) % 60);
                this.Time.minutes = Math.floor((payload.time / 1000 / 60) % 60);
                this.socket.emit("finished", {
                    time: this.Time.sinceStarted,
                    id: this.id
                })
            }
        })
        this.socket.on("add_point", async (id) => {
            if(this.id === id){
                this.Time.points += 1
            }
            await this.Sleep(8000)
            this.Time.minutes = 0
            this.Time.seconds = 0
            this.Time.milliseconds = 0
            this.Time.running = false
            this.Time.destroyed = false
            this.Time.sinceStarted = 0
        })
    },
    methods: {
        ClickStarter(){
            if(this.id == this.socket.id){
                this.handler()
            }
        },
        async handler(){
            if(this.Time.running){
                this.stop()
                await this.Sleep(500)
                this.socket.emit("stopped", {
                    roomId: this.roomId,
                    time: this.Time.sinceStarted,
                    id: this.id
                })
                return
            }
            this.socket.emit("started", this.roomId)
            this.start()
        },
        start(){
            if(this.Time.destroyed){
                return
            }
            const startTime = new Date()
            this.Time.running = true
            const timeInterval = setInterval(() => {
                this.Time.sinceStarted = new Date() - startTime
                this.Time.milliseconds = Math.floor(this.Time.sinceStarted % 1000)
                this.Time.seconds = Math.floor((this.Time.sinceStarted / 1000) % 60);
                this.Time.minutes = Math.floor((this.Time.sinceStarted / 1000 / 60) % 60);
                if(!this.Time.running){
                    clearInterval(timeInterval)
                    return
                }
            }, 10); 
        },
        async stop(){
            this.Time.running = false
            this.Time.destroyed = true
            await this.Sleep(500)
            if(this.socket.id === this.id){
                this.socket.emit("finished", {
                    time: this.Time.sinceStarted,
                    id: this.id
                })
            }
        },
        Sleep(milliseconds) {
            return new Promise(resolve => setTimeout(resolve, milliseconds));
        },
    },
    computed: {
        calculateMinutes: function (){
            const minutes = this.Time.minutes
            if(minutes < 10){
                return "0" + minutes.toString()
            }
            return minutes.toString()
        },
        calculateSeconds: function (){
            const Seconds = this.Time.seconds
            if(Seconds < 10){
                return "0" + Seconds.toString()
            }
            return Seconds.toString()
        },
        calculateMilliseconds: function (){
            const milliseconds = this.Time.milliseconds
            if(milliseconds < 10){
                return "00" + milliseconds.toString()
            }
            else if(milliseconds < 100){
                return "0" + milliseconds.toString()
            }
            return milliseconds.toString()
        }
    },
    
}
</script>

<style>

</style>